<template>
  <div class="index">
    <van-nav-bar title="编辑病例" fixed left-arrow @click-left="$router.back()" style="z-index: 9999999" />
    <!-- 内容 -->
    <div class="box">
      <!-- 上传病例 -->
      <div class="box-form">
        <el-form :model="form" :rules="rules" ref="form" label-position="top">
          <el-form-item label="病例标题：" prop="title" style="width: 100%;">
            <el-input v-model="form.title" placeholder="请输入病例标题"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="上传病例：" prop="case_url" class="case">
              <el-upload class="upload-demo" :limit="1" :action="action" :on-remove="handleRemove"
                :before-remove="beforeRemove" :on-success="handleAvatarSuccess" multiple :file-list="fileList"
                :before-upload="wenBeforeUpload" :on-progress="onProgressTest" :data="uploadData" accept=".ppt,.pptx">
                <el-button size="small" type="primary" v-prevent="1500">上传病例资料</el-button>
              </el-upload>
            </el-form-item>
          </div>
          <!-- <div> <a class="case-a" @click="mobandow">下载病例资料</a></div> -->
          <div class="btn">
            <el-button v-if="true" style="width: 100px;height: 40px;font-size: 14px;border-radius: 6px;" type="primary"
              @click="submitForm('form')">
              发布病例
            </el-button>
            <el-button v-else style="width: 100px;height: 40px;font-size: 14px;border-radius: 6px;" type="primary"
              @click="">
              个人中心
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  data() {
    return {
      action: `https://up-z0.qiniup.com`,
      fileList: [],
      uploadData: { key: "", token: "" },
      form: { title: '', case_url: '', id: '' },
      rules: {
        title: [
          { required: true, message: '请输入病例标题', trigger: 'blur' }
        ],
        case_url: [
          { required: true, message: '请上传病例', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getform()
    this.form.id = this.$route.query.id
  },
  methods: {
    //上传前    
    async wenBeforeUpload(file) {
      let suffix = this.getFileType(file.name) //获取文件后缀名
      let suffixArray = ['ppt', 'pptx'] //限制的文件类型，根据情况自己定义 
      if (suffixArray.indexOf(suffix) === -1) {
        // this.$message({
        //   message: '文件格式错误',
        //   type: 'error',
        //   duration: 2000  
        // })
        this.$toast("文件格式错误,请上传ppt格式");
      } else {
        //获取七牛云的token
        const { data: data } = await this.$http.get("system/qiniuToken");
        this.uploadData.token = data.data.token;
        this.uploadData.key = `medical/${this.year}/${this.month}/${this.day}/${file.uid}${file.name}`;
        // return true;
        return suffixArray
      }
    },
    getFileType(name) {
      let startIndex = name.lastIndexOf('.')
      if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
      } else {
        return ''
      }
    },
    //文件上传时
    onProgressTest(event, file, fileList) {
      let index = 0;
      fileList.forEach((v, i) => {
        if (v.uid === file.uid) {
          index = i;
        }
      });
      // 获取动态的进度
      let percent = parseInt(event.percent);
      this.$nextTick(() => {
        setTimeout(() => {
          if (percent >= 99) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
            let dom = document.getElementsByClassName("el-upload-list__item")[
              index
            ];
            let progressText = dom.getElementsByClassName("el-progress__text");
            if (progressText && progressText.length) {
              progressText[0].style.opacity = 0;
              progressText[0].innerText = "99%";
              progressText[0].style.opacity = 1;
            }
          }
        });
      });
    },
    //文件上传成功
    handleAvatarSuccess(res, file) {
      if (res.key != "" || res.key != undefined || res.key != null) {
        this.form.case_url = `https://resources.car-t.medcase.com.cn/${res.key}`;
        this.$toast("上传成功");
      } else {
        this.$toast("上传失败");
      }
    },
    //移除文件 提示
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`); 
    },
    //移除后 
    handleRemove(file, fileList) {
      this.form.case_url = ''
    },
    //获取信息 
    async getform() {
      const { data: data } = await this.$http.get(
        "medical/case", { params: { id: this.$route.query.id } }
      );
      console.log(data);
      this.form.title = data.data.title
      this.form.case_url = data.data.case_url
      this.fileList = []
      this.fileList.push({ name: data.data.case_url, url: data.data.case_url })
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.getsubmitApi();
        } else {
          return false;
        }
      });
    },
    //提交表单
    async getsubmitApi() {
      const { data: data } = await this.$http.post(
        "medical/case",
        this.form
      );
      // this.$message({
      //   message: data.message,
      //   type: "success",
      // });
      this.$toast(data.message);
      this.$router.push({ path: "my/myCase" });
    },
    mobandow() {
      window.open('https://resources.car-t.medcase.com.cn/template/淋巴瘤CAR-T二线治疗全程管理项目.pptx');
    },
  }
}
</script> 
<style scoped>
.index {
  position: relative;
  top: 0;
  left: -15px;
  width: calc(100% + 30px);
  background: #fff;
}

.head-bgc {
  position: relative;
  width: 100%;
  height: 96px;
  background: url(@/assets/image/CARprocedure/bgc.png) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
}

.head-bgc-title {
  color: #130F0F;
  font-weight: 600;
  font-size: 18px;
  margin: 0 auto;
  text-align: center;
  padding-top: 28px;
}

.box {
  position: relative;
  top: -20px;
  left: 0;
  background: #fff;
  border-radius: 15px 15px 0px 0px;
  overflow: hidden;
  transition: all .3s;
  padding: 20px 15px;
}

.box-con {
  background-color: #fff;
  border-radius: 6px 6px 6px 6px;
  padding: 20px 12px;
}

.box-head {
  position: relative;
  display: flex;
  align-items: center;
}

.box-head-title {
  position: relative;
  margin-left: 10px;
  color: #000;
  font-size: 15px;
  font-weight: 600;
  z-index: 99;
  margin-right: 24px;
}

.box-head-img {
  position: absolute;
  top: 14px;
  left: 0;
  width: 62px;
  height: 12px;
}

.box-head-text {
  position: relative;
  color: #8E8E8E;
  font-size: 13px;
}

.box-one {
  width: 321px;
  height: 122px;
  cursor: pointer;
  margin: 26px 0 47px;
}

.box-form {
  position: relative;
}

.case {
  position: relative;
}

.case-a {
  color: #2567E9;
  position: absolute;
  top: 10px;
  left: 120px;
  text-decoration: underline;

}

.case-text {
  color: #8E8E8E;
  margin-top: 10px;
}

.btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 150px;
}
</style> 